// Agency member salon access rules — single source for the API (salon visibility,
// salon setup gates) and the web (Members page, salon card) so they can never drift.
// `role` gates authority (money, plan, members); these two settings only widen what a
// MEMBER can see and set up. Admins implicitly have both.

/** `ASSIGNED` = only salons with an active access row; `ALL_SALONS` = every salon, including new ones. */
export const AGENCY_SALON_SCOPES = ['ASSIGNED', 'ALL_SALONS'] as const;
export type AgencySalonScope = (typeof AGENCY_SALON_SCOPES)[number];

/**
 * The fields the rules read. Scope and setup flag are optional so a web build that ships
 * before the API (or a partial test mock) falls back to today's behavior: ASSIGNED, no setup.
 */
export type AgencyMemberAccessFields = {
  role: 'ADMIN' | 'MEMBER';
  salonScope?: AgencySalonScope | null;
  canManageSalonSetup?: boolean | null;
};

/** Admins and ALL_SALONS members see every salon; everyone else sees only assigned salons. */
export function agencyMemberSeesAllSalons(member: AgencyMemberAccessFields): boolean {
  return member.role === 'ADMIN' || member.salonScope === 'ALL_SALONS';
}

/** Admins and members with the Salon setup flag can create salons and toggle setup switches in scope. */
export function agencyMemberCanManageSalonSetup(member: AgencyMemberAccessFields): boolean {
  return member.role === 'ADMIN' || member.canManageSalonSetup === true;
}
